import { Map } from 'immutable';

import gatwick from './gatwick';


/**
 * Custom messages for Gatwick Express - British Airways
 */

const micrositeMessages = new Map({
    'app.owner': 'Gatwick Express - British Airways'
});

export default gatwick.merge(micrositeMessages);
